// extracted by mini-css-extract-plugin
export default {"personalPlan":"styles_personalPlan__dzFwP","plan":"styles_plan__UUuTC","header":"styles_header__kOv25","propertiesList":"styles_propertiesList__Yco8n","item":"styles_item__B4TVf"};